<template>
  <div>
    <audio
      :width="innerWidth"
      :height="innerHeight"
      id="player"
      @click="playPause"
    >
      <source :src="video_link" type="audio/ogg" />
      <source :src="video_link" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>

    <span class="recording-playbtn" @click="playPause" v-if="playerPause">
      <RecordPlayIcon />
    </span>
  </div>
</template>

<script>
import RecordPlayIcon from './svgIcons/RecordPlayIcon';

export default {
  name: 'Player',

  props: ['video_link', 'poster', 'id'],

  components: {
    RecordPlayIcon,
  },

  data() {
    return {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      popoverlayBg: true,
      canClose: false,
      flowplayer: null,
      player: null,
      playerPause: false,
    };
  },

  mounted() {
    this.player = document.getElementById('player');
    let t = this;
    t.$store.dispatch('setIsStartAutoplay', false);
    this.player.onended = function() {
      t.$store.dispatch('setIsStartAutoplay', true);
    };
    this.player.controls = false;
    this.player.playbackRate = 1.5;
    var _this = this;
    __native_money91._onPause = () => {
      console.log('pause');
      _this.player.pause();
      this.playerPause = true;
    };
    __native_money91._onResume = () => {
      console.log('resume');
      _this.player.pause();
      this.playerPause = true;
    };
  },

  methods: {
    playPause() {
      this.playerPause ? (this.playerPause = false) : (this.playerPause = true);
      this.playerPause ? this.player.pause() : this.player.play();
    },
  },
  beforeDestroy() {
    this.player.pause();
  },
};
</script>
